import flatpickr from "flatpickr";

jQuery( document ).ready(function($){

    /* Events Filters - 'Select A Date' Field - When 'daterange' is selected 
    ------------------------------------------------------------------------- */
    $('.filter-daterange').change(function() {
        if ( $('.filter-daterange').val() == 'daterange' ) {
            $('#date-dropbox').css('display', 'none');
            $('#date-container').css('display', 'flex');
        } else {
            $('#date-container').css('display', 'none');
        }
    });
    

    /* Events Filters - On Page Load - if 'Select A Date' Field has 'daterange' selected
    -------------------------------------------------------------------------------------- */
    if ( $('.filter-daterange').val() == 'daterange' ) {
        $('#date-dropbox').css('display', 'none');
        $('#date-container').css('display', 'flex');
        $('#from-date').val(getUrlParameter('from-date'));
        $('#to-date').val(getUrlParameter('to-date'));
    } else {
        $('#date-container').hide();
    }

    /* Events Filters - Setting Date field Format
    ------------------------------------------------ */
    $('#from-date, #to-date').flatpickr({
        dateFormat: "d/m/Y",
    });

    /* Events Filters - Clicking X that appears when Date Range is selected
    ------------------------------------------------------------------------- */
    $('#show-dropbox').click(function(e){
        e.preventDefault();
        $('#date-dropbox').css('display', 'flex');
        $('#date-container').css('display', 'none');
        $('.filter-daterange').val('any');
    })
});

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};